import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import staticData from '../config/staticData'

import { moment } from '../utils/dates'
import 'moment/locale/fr'
import 'moment/locale/de'
import 'moment/locale/nl'

import { v1requestAirports } from '../actions/airports'
import {
  v1setUserCustomTOPCodeFromSessionStore,
  v1requestUser,
} from '../actions/users'

import App from '../components/App'

moment.locale(staticData.lang)

export const mapStateToProps = (state: any) => ({
  searchQuery: state.v1searchQuery,
  shouldLoadAirports:
    !(Boolean(state.v1airports) && Boolean(state.v1airports.items.length)) && Boolean(!state.v1airports.isFetching),
  user: state.v1user,
  error: state.v1error
})

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      getAirports: v1requestAirports,
      setUserTOPCode: v1setUserCustomTOPCodeFromSessionStore,
      requestUser: v1requestUser,
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App)
